// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AccordionController from "./accordion_controller"
application.register("accordion", AccordionController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import GlightboxController from "./glightbox_controller"
application.register("glightbox", GlightboxController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import LazyloadController from "./lazyload_controller"
application.register("lazyload", LazyloadController)

import MasterController from "./master_controller"
application.register("master", MasterController)

import NavigationController from "./navigation_controller"
application.register("navigation", NavigationController)

import PartnerController from "./partner_controller"
application.register("partner", PartnerController)

import ScrollBackgroundController from "./scroll_background_controller"
application.register("scroll-background", ScrollBackgroundController)

import SplidejsController from "./splidejs_controller"
application.register("splidejs", SplidejsController)

import SwiperController from "./swiper_controller"
application.register("swiper", SwiperController)
